import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PublicAssetAbstractProductData, Product } from 'store/studioSearch/types';
import cn from 'classnames';
import styles from './ProductSelectPopupMobile.module.scss';

export interface ProductSelectPopupMobileProps {
  publicAssetAbstractProduct?: PublicAssetAbstractProductData;
}

const ProductSelectPopupMobile: FC<ProductSelectPopupMobileProps> = ({ publicAssetAbstractProduct }) => {
  const [selectedProduct, setSelectedProduct] = useState<Product | undefined>(publicAssetAbstractProduct?.products[0]);
  const { t } = useTranslation();

  const routeToFollowUrl = () => {
    if (selectedProduct?.followUrl) {
      window.location.href = selectedProduct.followUrl;
    }
  };

  return (
    <div className={styles.productType}>
      <div className={styles.preview}>
        <img src={selectedProduct?.illustrationUrl || ''} alt="Product illustration" />
      </div>
      <div className={styles.previewPicker}>
        {publicAssetAbstractProduct?.products.map((product) => (
          <div
            className={cn(styles.previewPickerItem, {
              [styles.active]: selectedProduct?.productId === product.productId,
            })}
            onClick={() => setSelectedProduct(product)}
          >
            <img src={product.illustrationUrl} alt="Small illustration preview" />
            <div className={styles.previewPickerItemName}>{product.name}</div>
          </div>
        ))}
      </div>
      <div className={styles.productDescription}>
        <div className={styles.name}>{selectedProduct?.name}</div>
        <div className={styles.description}>{selectedProduct?.description}</div>
        <div className={styles.price}>
          {selectedProduct?.finalPrice.value !== selectedProduct?.initialPrice.value && (
            <>
              <span
                className={styles.initialPrice}
                dangerouslySetInnerHTML={{ __html: selectedProduct?.initialPrice.formatted || '' }}
              />
              <span
                className={styles.dicountedPrice}
                dangerouslySetInnerHTML={{ __html: selectedProduct?.finalPrice.formatted || '' }}
              />
            </>
          )}
          {selectedProduct?.finalPrice.value === selectedProduct?.initialPrice.value && (
            <span dangerouslySetInnerHTML={{ __html: selectedProduct?.finalPrice.formatted || '' }} />
          )}
        </div>
      </div>
      <div className={styles.actions} onClick={() => routeToFollowUrl()}>
        <button>{t('txt_fit_wall')}</button>
      </div>
    </div>
  );
};

export default ProductSelectPopupMobile;
